export const accident = {
    IS_ACCIDENT: 'IS_ACCIDENT',
    NO_ACCIDENT: 'NO_ACCIDENT',
};
